import { SettingsTabKey } from "./tabs";

export const settingsExpandedSegment = "settings/expanded";

export const settingsPath = "/embedded/settings";

const settingsExpandedPath = `/embedded/${settingsExpandedSegment}`;

export const settingsTabPath = (tab?: SettingsTabKey) =>
  tab ? `${settingsPath}?tab=${tab}` : settingsPath;

export const settingsExpandedTabPath = (tab?: SettingsTabKey) =>
  tab ? `${settingsExpandedPath}?tab=${tab}` : settingsExpandedPath;

export const builderPath = "/embedded/builder";

export const builderWindowCloseParam = "windowclose";

export const builderReminderMessagePath = (
  reminderMessage: "custom" | "default",
  windowClose: boolean = true,
) => {
  const params = new URLSearchParams({ reminderMessage });
  if (!windowClose) params.set(builderWindowCloseParam, "false");

  return `${builderPath}?${params}`;
};
